import { Stack, Typography } from "@mui/material";
import {
  BooleanInput,
  Edit,
  ListButton,
  minValue,
  number,
  NumberInput,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { useClientApps } from "@/modules/clientApps";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
  </TopToolbar>
);

export const AppVersionFlagEdit = () => {
  const { data: { clientAppsList } = {} } = useClientApps();

  return (
    <Edit
      actions={<EditActions />}
      title="App Version Flag"
      mutationMode="pessimistic"
    >
      <SimpleForm toolbar={<EditToolbar />}>
        <SelectInput
          label="App"
          source="clientAppId"
          validate={required()}
          choices={clientAppsList}
        />
        <Typography variant="body2" color="textSecondary">
          Semver
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          divider={<span>.</span>}
        >
          <NumberInput
            source="major"
            validate={[required(), number(), minValue(0)]}
          />
          <NumberInput
            source="minor"
            validate={[required(), number(), minValue(0)]}
          />
          <NumberInput
            source="patch"
            validate={[required(), number(), minValue(0)]}
          />
        </Stack>
        <BooleanInput label="Allow di" source="di" />
      </SimpleForm>
    </Edit>
  );
};
